import { queryOptions } from "@tanstack/react-query";
import { notFound } from "@tanstack/react-router";
import { ApiError, api, expectOk } from "../../lib/api";
import { keys } from "../../lib/keys";

export const GIFT_PAGE_SIZE = 20;

export interface GiftListFilters {
  q?: string;
  page: number;
}

export const giftListQuery = (filters: GiftListFilters) =>
  queryOptions({
    queryKey: keys.gifts({ q: filters.q ?? "", page: filters.page }),
    queryFn: async () =>
      expectOk(
        await api.gifts.list({
          query: { q: filters.q, page: filters.page, pageSize: GIFT_PAGE_SIZE },
        }),
        200,
      ),
  });

export const giftDetailQuery = (giftCardId: string) =>
  queryOptions({
    queryKey: keys.gift(giftCardId),
    queryFn: () =>
      api.gifts
        .detail({ params: { giftCardId } })
        .then((r) => expectOk(r, 200))
        .catch((e: unknown) => {
          if (e instanceof ApiError && (e.status === 404 || e.code === "invalid_id")) {
            throw notFound();
          }
          throw e;
        }),
  });
